// Unity 左手系 → Three.js 右手系 の座標変換ヘルパ。
// Z を反転し、三角形のワインディングも反転して表裏を保つ。

/** vec3 配列の Z 成分を反転した新しい配列を返す */
export function flipZVec3(src: Float32Array): Float32Array {
  const out = new Float32Array(src.length);
  for (let i = 0; i < src.length; i += 3) {
    out[i] = src[i];
    out[i + 1] = src[i + 1];
    out[i + 2] = -src[i + 2];
  }
  return out;
}

/** tangent(xyzw) 配列の Z と handedness を反転した新しい配列を返す */
export function flipZTangent(src: Float32Array): Float32Array {
  const out = new Float32Array(src.length);
  for (let i = 0; i < src.length; i += 4) {
    out[i] = src[i];
    out[i + 1] = src[i + 1];
    out[i + 2] = -src[i + 2];
    out[i + 3] = -src[i + 3];
  }
  return out;
}

/** 三角形ごとに 2 番目と 3 番目のインデックスを入れ替える（CCW ↔ CW） */
export function flipWinding<T extends Uint16Array | Uint32Array>(src: T): T {
  const out = src.slice() as T;
  for (let i = 0; i + 2 < out.length; i += 3) {
    const b = out[i + 1];
    out[i + 1] = out[i + 2];
    out[i + 2] = b;
  }
  return out;
}

/** Unity クォータニオン (x,y,z,w) → Three.js 用（Z 反転系に合わせて x,y を反転） */
export function flipZQuaternion(q: readonly [number, number, number, number]): [number, number, number, number] {
  return [-q[0], -q[1], q[2], q[3]];
}
